export const CSRF_TOKEN_ATTR = 'data-csrf';

let prepareParams = function(params) {
  let data = '';
  let i = 0;

  for (let key in params) {
    data += `${i > 0 ? '&' : ''}${key}=${params[key]}`;
    i++;
  };

  return data;
};

export function xhrLoad(url, onload = null, onFail = null, method = 'get', params = '') {
  if (window.lastXhr && window.lastXhrUrl && window.lastXhrUrl === url) {
    window.lastXhr.abort();
  }

  // eslint-disable-next-line no-undef
  let xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        if (typeof onload === 'function') {
          onload(xhr.responseText);
        }
      }
      else {
        if (typeof onFail === 'function') {
          onFail(xhr.responseText);
        }
      }
    }
  };

  xhr.open(method, url, true);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.setRequestHeader('X-CSRF-Token', document.body.getAttribute(CSRF_TOKEN_ATTR));
  xhr.send(prepareParams(params));

  window.lastXhr = xhr;
  window.lastXhrUrl = url;
}
